import React from 'react';

const DeepSeekMoment = () => (
  <article className="news-article-body">
    <p className="news-lead">
      On January 20, 2025, Chinese AI startup DeepSeek released its <strong>R1 reasoning model</strong>
      — and triggered the largest single-day market capitalisation loss in US stock market history.
      NVIDIA alone lost approximately <strong>$600 billion</strong> in market cap as its stock
      plummeted 17% in a single session.
    </p>

    <h2>What DeepSeek R1 Actually Was</h2>
    <p>
      DeepSeek R1 is a <strong>reasoning model</strong> — trained to "think" through problems
      step-by-step before answering, similar to OpenAI's o1. In benchmark evaluations, R1
      demonstrated performance comparable to OpenAI's o1 across mathematics, coding, and
      scientific reasoning tasks.
    </p>
    <p>
      The model was released openly, with weights available for download. This meant anyone
      could run it locally — no API dependency, no per-token costs.
    </p>

    <h2>The Cost Claim That Shook Markets</h2>
    <p>
      DeepSeek reported that R1's training cost approximately <strong>$5.6 million</strong> —
      compared to estimates of <strong>$100M+</strong> for OpenAI's GPT-4. Whether this figure
      accurately represents total compute expenditure (or excludes earlier research runs) remains
      debated. However, the directional message was clear: competitive frontier AI could be
      built far more cheaply than Silicon Valley assumed.
    </p>
    <p>
      The prevailing assumption had been that scaling AI required ever-more-expensive clusters
      of NVIDIA chips — a thesis that underpinned NVIDIA's extraordinary valuation. DeepSeek's
      apparent efficiency shattered that assumption, at least temporarily.
    </p>

    <h2>The "Sputnik Moment" Analogy</h2>
    <p>
      Many commentators described the event as AI's "Sputnik moment" — a reference to the 1957
      Soviet satellite launch that shocked the US into its space programme. The parallel was the
      sudden revelation that a competitor had achieved something previously believed to require
      resources only available to a few actors.
    </p>
    <p>
      The analogy is imperfect: DeepSeek's model was openly published and available to all,
      unlike Sputnik. But the psychological disruption to the AI industry's confidence in
      American dominance was real.
    </p>

    <h2>Market Impact</h2>
    <ul>
      <li><strong>NVIDIA</strong>: –17%, ~$600B market cap wiped in one day</li>
      <li><strong>Google, Amazon, Microsoft, Tesla</strong>: All declined significantly</li>
      <li><strong>DeepSeek app</strong>: Reached #1 on the US App Store, surpassing ChatGPT</li>
    </ul>

    <h2>The Recovery and Lasting Impact</h2>
    <p>
      NVIDIA's stock recovered within weeks and by mid-2025 had become the first company to
      reach a <strong>$5 trillion market cap</strong>. The reasoning was that cheaper inference
      increases AI adoption, which increases demand for NVIDIA's training chips for the next
      generation of models.
    </p>
    <p>
      But the lasting impact was a shift in how AI labs think about efficiency. The "DeepSeek
      moment" validated techniques like <strong>distillation</strong> (training smaller models
      from larger ones), <strong>sparse MoE architectures</strong>, and
      <strong>reinforcement learning from verifiable rewards</strong> — all of which DeepSeek
      used extensively.
    </p>

    <div className="news-insight-box">
      <h3>Key Takeaway</h3>
      <p>
        Efficiency is the new frontier. DeepSeek demonstrated that algorithmic innovation can
        substitute for raw compute — and that assuming any single actor has a permanent
        lead in AI capability is dangerous. The open-source release of R1 also accelerated
        the entire field by giving every researcher access to a frontier-class reasoning model.
      </p>
    </div>
  </article>
);

export default DeepSeekMoment;
